module.exports = __webpack_public_path__ + "assets/543f282100e5d5525077e90efb76a379.mp4";